var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMinusCircle = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/minus-cirlce"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus-cirlce"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.92 22.75C6.00004 22.75 1.17004 17.93 1.17004 12C1.17004 6.07 6.00004 1.25 11.92 1.25C17.84 1.25 22.67 6.07 22.67 12C22.67 17.93 17.85 22.75 11.92 22.75ZM11.92 2.75C6.82004 2.75 2.67004 6.9 2.67004 12C2.67004 17.1 6.82004 21.25 11.92 21.25C17.02 21.25 21.17 17.1 21.17 12C21.17 6.9 17.02 2.75 11.92 2.75Z",
    fill: "#C90000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.92 12.75H7.92004C7.51004 12.75 7.17004 12.41 7.17004 12C7.17004 11.59 7.51004 11.25 7.92004 11.25H15.92C16.33 11.25 16.67 11.59 16.67 12C16.67 12.41 16.34 12.75 15.92 12.75Z",
    fill: "#C90000"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMinusCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/minus-circle.b69d1e84.svg";
export { ForwardRef as ReactComponent };